// Move sticky header out of .page-content (overflow-hidden/sticky conflict).
document.addEventListener('DOMContentLoaded', () => {
	const subnavigation = document.querySelector('.page-content > .block-subnavigation');
	const pageContent = document.querySelector('.page-content');
	const parentContainer = pageContent?.parentNode;

	// Check if all required elements are found
	if (subnavigation && pageContent && parentContainer) {
		// Move .block-subnavigation before .page-content
		parentContainer.insertBefore(subnavigation, pageContent);
	}
});
